/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// import React from "react";
// import ReactDOM from "react-dom";
// import { BrowserRouter } from "react-router-dom";
// import App from "App";


// //For multilanguage suppot
// import "./i18nextConf";

// // Material Dashboard 2 React Context Provider
// import { MaterialUIControllerProvider } from "context";

// ReactDOM.render(
//   <BrowserRouter>
//     <MaterialUIControllerProvider>
//       <App />
//     </MaterialUIControllerProvider>
//   </BrowserRouter>,
//   document.getElementById("root")
// );

import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import axios from "axios";
import configurations from "config";
import CircularProgress from "@mui/material/CircularProgress";


// For multilanguage support
import "./i18nextConf";
import { useTranslation } from "react-i18next";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";

const container = document.getElementById("app");
const root = createRoot(container);

const Index = () => {

  const baseUrl = configurations.baseUrl;
  const azureFunctionVendorFrontendKey = configurations.azureFunctionVendorFrontendKey;
  const { t } = useTranslation();
  const [settings, setSettings] = useState(null);
  const [error, setError] = useState(null);
  



  const fetchData = async () => {
    try {
      const response = await axios.get(baseUrl + '/configuration/frontEndSettings', {
        headers: { function: azureFunctionVendorFrontendKey }
      });

      const requestStatus = response.status;
      if (requestStatus === 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status === 1) {
          const data = response.data.data;
          setSettings(data);
        } else {
          console.log(t(message));
          if (message !== '') {
            alert(t(message));
          }
        }
      } else {
        alert(t('unableToProccessRequest'));
      }
    } catch (error) {
      console.log(error);
      if (error.response && error.response.status === 403) {
        if (error.response.data.message === '') {
          alert(error.response.statusText);
        } else {
          if (error.response.data.message === 'unableToConnectDatabase') {
            alert(t(error.response.data.message));
          } else {
            localStorage.clear();
          }
        }
      } else {
        alert(error.message);
      }
    }
  };
  
  useEffect(() => {
 
    fetchData();
  }, []);

  if (error) {
    // Render an error message if there was an error while fetching settings
    return <div>Error fetching settings: {error.message}</div>;
  }

  if (!settings) {
    // Render a loading state while settings are being fetched
    return <div className="loadingCircularProgress">
        <CircularProgress color='inherit' size={40} />
    </div>;
  }

  // Render the app with the fetched settings
  return (
    <BrowserRouter>
      <MaterialUIControllerProvider settings={settings}>
        <App />
      </MaterialUIControllerProvider>
    </BrowserRouter>
  );
};

// ReactDOM.render(<Index />, document.getElementById("root"));
// createRoot(document.getElementById('root')).render(<Index />);
root.render(
  <Index />
  );
